<template>
  <div id="main">
    <div class="main">
      <left-nav :topNav="topNav" :secNav="secNav" :thirdNav="thirdNav"></left-nav>
      <main-right></main-right>
    </div>
  </div>
</template>

<script>
import LeftNav from './components/left-part/Leftnav'
import MainRight from './components/right-part/Mainright'
export default {
  name: 'firstScreen',
  components: {
    LeftNav,
    MainRight
  },
  props: ['topNav', 'secNav', 'thirdNav']
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
#main
  width: 100%
  height :382px
  margin-bottom: 10px
  .main
    width: $defaultwidth
    display: flex
    margin: 0 auto
    position: relative
</style>



// WEBPACK FOOTER //
// src/pages/home/components/swiper/Swiper.vue